import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { UserService } from '../user.service';
import { ParamHandlingService } from '@services/misc-services/param-handling.service';
import { AcmicService } from '@mapfre-design-library/src/public_api';

@Injectable({
  providedIn: 'root',
})
export class ValidateEmailService {
  constructor(private http: HttpClient, private userService: UserService, 
    private paramHandlingService: ParamHandlingService, private acmicService:AcmicService) {}

  checkActiveEmail(email: string) {
    const url = `${
      environment.backend_server_url_account
    }/check-customer?email=${email.toLowerCase()}`;
    return this.http.get(url);
  }

  sendValidationEmail(email: string) {
    const url = `${
      environment.backend_server_url_identity
    }/guest/resend/${email.toLowerCase()}`;
    return this.http.get(url);
  }

  getUserDataByEmail(email: string) {
    const url = `${
      environment.backend_server_url_account
    }/guest/${email.toLowerCase()}/name`;
    return this.http.get(url);
  }



  sendValidationEmailForNonCommercial(newEmail, oldEmailId?, isEmailChanged?) {
    let pn;
    const user: any = this.userService.getUserInfoInStorage();
    const formatPolicyNumber = (policyNumber: string) =>
      policyNumber?.replace(/-/g, '')?.toUpperCase();

    if (user.policyDetail) {
      if (user.policyDetail.policynumber.length > 1) {
        pn = user.policyDetail.policynumber.map((item: any) => ({
          ...item,
          policyNumber: formatPolicyNumber(item.policyNumber),
        }));
      } else {
        pn = [
          {
            policyNumber: formatPolicyNumber(
              user.policyDetail.policynumber.policyNumber ||
                user.policyDetail.policynumber[0].policyNumber
            ),
          },
        ];
      }
    }

    const payLoad: any = {
      customer: {
        firstName: user['userDetails']['firstName'],
        middleName: '',
        lastName: user['userDetails']['lastName'],
        email: {
          email: newEmail,
        },
        phoneList: user['userDetails']['phoneList'],
        publicId: user['userDetails']['publicId'],
      },
      policynumbers: pn,
    };
    if (isEmailChanged) {
      payLoad.customer = {
        ...payLoad.customer,
        oldEmail: {
          email: oldEmailId,
        },
      };
    }
    if (user && user.userDetails && user.userDetails.zipCode) {
      payLoad.customer.zipCode = user.userDetails.zipCode;
    }
    const queryParamsStr = this.paramHandlingService.getUtmQueryParamStr();
    let url = `${environment.backend_server_url_account}/guest/v2/verify-customer`;

    if(this.acmicService.isACMIC() && queryParamsStr.length) {
      url = `${environment.backend_server_url_account}/guest/v2/verify-customer?${this.paramHandlingService.getUtmQueryParamStr()}`;
    }
    return this.http.post(url, payLoad);
  }
}
